var wordBreaks = new Set(["normal", "break-all", "keep-all", "break-word"]);
export default (function (_a) {
    var wordBreak = _a.wordBreak;
    return wordBreaks.has(wordBreak) && "word-break: ".concat(wordBreak, ";");
});
